function generateDate() {
    const dayNames = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
    const monthNames = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];
    const date = new Date();
    let day = date.getDate();
    let month = date.getMonth();
    let dayOfWeek = date.getDay();

    let todaysDate = dayNames[dayOfWeek]  + ' ' + monthNames[month] + ' ' + day
    return [todaysDate, dayOfWeek]
}

export default generateDate;